<div class="pmd-switch">
  <label>
    <input
      #input
      type="checkbox"
      [id]="id"
      [checked]="checked"
      [disabled]="disabled"
      [required]="required"
      [indeterminate]="indeterminate"
      [attr.name]="name"
      [attr.value]="value"
      [tabIndex]="tabIndex"
      (click)="onSwitchClick($event)"
      (change)="onSwitchChange($event)"
      [attr.aria-label]="ariaLabel"
    />
    <span class="pmd-switch-label"></span>
    <ng-content></ng-content>
  </label>
</div>
